import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-[#DDDDFB] border border-[#DDDDFB] w-full h-[44px] rounded-primary-radius px-3 flex items-center justify-center text-primary-text-color text-base leading-5 tracking-[0.01rem] font-semibold" }



type Props = {
  buttonText: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnareButtonColor',
  props: {
    buttonText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(__props.buttonText), 1))
}
}

})